module.exports = __webpack_public_path__ + "static/assets/55db3a8b0cc7419b816f748732706cab.png";